import { rfqQuoteDetailsProposedDetailsGridStyles } from "@insite/content-library/Widgets/RfqQuoteDetails/RfqQuoteDetailsProposedDetailsGrid";
import { css } from "styled-components";

rfqQuoteDetailsProposedDetailsGridStyles.headerWrapper = {
    css: css`
        display: flex;
        padding-bottom: 15px;
        border-bottom: none;
    `,
};
